/* eslint-disable */
export const protobufPackage = 'com.celertech.orderrouting.api.enums.accounttype';

export enum AccountType {
    CLIENT = 1,
    HOUSE = 2,
    RISKLESS_PRINCIPLE = 3,
    UNRECOGNIZED = -1
}
